module.exports = __webpack_public_path__ + "static/media/bg-pic-contact.941d29f1.jpg";